module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_4.9f453d49.png";